var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover"},[_c('h1',[_vm._v(_vm._s(_vm.course.goal))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.course.curator))]),_vm._v(" "),(_vm.course.date && _vm.course.location)?_c('h3',[_vm._v(_vm._s(_vm.course.date)+" // "+_vm._s(_vm.course.location))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d897981c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CoverPage.vue
// module id = 246
// module chunks = 0